import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Tabs from './../common/components/Tabs';
import AdminHeader from './../common/components/AdminHeader';
import { Table, Form, Delete, ActivePapers, SpeedTable, DiscountTable } from './components';
import * as selectors from './selectors';
import * as actions from './actions';
import * as dialog from '../common/dialog';
import * as loginSelectors from './../Login/Login.selectors';
import moment from 'moment';
import numeral from 'numeral';
import { Helmet } from 'react-helmet';
import cloneDeep from 'lodash/cloneDeep';
import { showNotification } from './../../utils';
import Layout from './../Layout';

class Container extends Component {
    static propTypes = {};

    componentDidMount() {
        const { fetchElements, sortColumn, sortType, filterFields } = this.props;
        fetchElements(1, sortColumn, sortType, filterFields);
    }

    componentWillUnmount() {
        const { resetState } = this.props;
        resetState();
    }

    handleUpdateFormValue(type, required, event) {
        const { setFormError, formValues, fetchPaperWeights, fetchPapers, updateState } = this.props;

        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        let values = {};
        values[event.target.name] = value;
        let newValues = cloneDeep(formValues);
        newValues[event.target.name] = value;

        let error = false;
        let errorMessage = '';
        if (required && value === '') {
            error = true;
            errorMessage = 'This field is required';
        } else {
            if (value !== '' && type === 'number' && value.toString().match(/^[0-9]+$/) === null) {
                error = true;
                errorMessage = 'This value needs to be a number';
            } else if (value !== '' && type === 'decimal' && value.toString().match(/^([0-9]*[.])?[0-9]+$/) === null) {
                error = true;
                errorMessage = 'This value needs to be a number';
            }
        }

        let fetching = {};
        let options = {};
        if (event.target.name === 'paper_category_id') {
            fetchPaperWeights(value);
            fetching.activePaperWeights = true;
            options.activePaperWeights = [];
            options.activePapers = [{ label: 'Select option', value: '' }];
        } else if (event.target.name === 'paper_weight') {
            fetchPapers(formValues['paper_category_id'], value);
            fetching.activePapers = true;
            options.activePapers = [];
            options.activePapers = [{ label: 'Select option', value: '' }];
        }

        let newState = { formValues: values };

        let keys = Object.keys(fetching);
        if (keys.length > 0) {
            newState.fetching = fetching;
        }

        keys = Object.keys(options);
        if (keys.length > 0) {
            newState.options = options;
        }

        updateState(newState);
        setFormError(event.target.name, error, errorMessage);
    }

    handleMultipleChange(name, event) {
        const { clearMultipleValue, concatMultipleValue } = this.props;
        clearMultipleValue(name);

        let values = [];
        for (let i = 0; i < event.target.options.length; i++) {
            if (event.target.options[i].selected) {
                values.push(parseInt(event.target.options[i].value));
            }
        }

        concatMultipleValue(name, values);
    }

    handleSort(column) {
        const { setSort, sortColumn, sortType, fetchElements, filterFields } = this.props;
        let type = 'asc';
        if (sortColumn === column) {
            type = sortType === 'asc' ? 'desc' : 'asc';
            setSort(column, type);
        } else {
            setSort(column, 'asc');
        }
        fetchElements(1, column, type, filterFields);
    }

    handleInlineChange(index, attribute, value) {
        const { elements, changeAttribute } = this.props;
        changeAttribute(value, elements, index, attribute);
    }

    handleDayChange(index, attribute, day) {
        const { elements, changeAttribute } = this.props;
        changeAttribute(moment(day).format('YYYY-MM-DD'), elements, index, attribute);
    }

    handleSaveElement() {
        const { saveElement, formValues, elements } = this.props;
        saveElement(formValues, elements);
    }

    handleShowForm(id) {
        const { showForm, resetForm, fetchElement } = this.props;

        if (id === null) {
            resetForm(id);
        } else {
            fetchElement(id);
        }

        showForm();
    }

    handleUpdateDayValue(name, day) {
        const { updateFormValue, setFormError } = this.props;
        updateFormValue(name, day);
        setFormError(name, day === '');
    }

    handleShowDelete(id, event) {
        const { showDelete, setIdForDelete } = this.props;
        event.preventDefault();
        showDelete();
        setIdForDelete(id);
    }

    handleDeleteElement() {
        const { deleteElement, idForDelete, elements } = this.props;
        deleteElement(idForDelete, elements);
    }

    handleChangeAttribute(index, attribute, type, value) {
        const { processedElements, changeAttribute, updateAttribute } = this.props;

        let valueToSave = value;
        if (type === 'money') {
            valueToSave = numeral(value).format('0.00');
            value = numeral(value).format('$0,0.00');
        } else if (type === 'number') {
            if (parseInt(value).toString().match(/^[0-9]+$/) === null) {
                showNotification('Wrong Value', 'This value needs to be a number', 'info');
                return;
            }
            valueToSave = numeral(value).format('0');
            value = numeral(value).format('0,0');
        } else if (type === 'date') {
            valueToSave = moment(value).format('YYYY-MM-DD');
            value = valueToSave;
        } else if (type === 'decimal') {
            if (parseInt(value).toString().match(/^([0-9]*[.])?[0-9]+$/) === null) {
                showNotification('Wrong Value', 'This value needs to be a number', 'info');
                return;
            }
            valueToSave = numeral(value).format('0');
            value = numeral(value).format('0,0');
        }

        changeAttribute(value, processedElements, index, attribute);
        updateAttribute(processedElements[index].id, attribute, valueToSave, processedElements, index);
    }

    handleShowActivePapers(id) {
        const { showActivePapers, fetchElement, fetchPaperCategories } = this.props;
        fetchElement(id);
        fetchPaperCategories();
        showActivePapers();
    }

    handleSaveActivePapers() {
        const { saveActivePapers, activePapers, activeElement, elements } = this.props;
        saveActivePapers(activePapers, elements, activeElement['id']);
    }

    handleAddActivePaper() {
        let { formValues, concatActiveData, information, showInfoNotification, updateFormValue } = this.props;
        let newPapers = [];
        for (let i = 0; i < information['papers'].length; i++) {
            if (formValues['active_paper_ids'].includes(information['papers'][i]['id'])) {
                newPapers.push(information['papers'][i]);
            }
        }

        if (newPapers.length === 0) {
            showInfoNotification('Select a paper');
        } else {
            concatActiveData('activePapers', newPapers);
            updateFormValue('active_paper_ids', []);
        }
    }

    handleDeleteActivePaper(id) {
        let { activePapers, deleteActiveData } = this.props;

        for (let i = 0; i < activePapers.length; i++) {
            if (activePapers[i]['id'] === id) {
                deleteActiveData(i, 'activePapers');
                break;
            }
        }
    }

    handleShowSpeedTable(id) {
        const { showSpeedTable, fetchElement } = this.props;
        fetchElement(id);
        showSpeedTable();
    }

    handleAddSpeedTable() {
        let { setSpeedTable, speedTable } = this.props;
        speedTable.push({ id: '', width: '', length: '', sides: '', speed: '' });
        setSpeedTable(speedTable);
    }

    handleUpdateSpeedTable(index, attribute, event) {
        let { setSpeedTable, speedTable } = this.props;
        speedTable[index][attribute] = event.target.value;
        setSpeedTable(speedTable);
    }

    handleDeleteSpeedTable(index) {
        let { setSpeedTable, speedTable } = this.props;
        speedTable.splice(index, 1);
        setSpeedTable(speedTable);
    }

    handleSaveSpeedTable() {
        const { saveSpeedTable, speedTable, activeElement, elements } = this.props;
        saveSpeedTable(speedTable, elements, activeElement['id']);
    }

    handleChangeFilter(name, event) {
        const { changeFilter, fetchElements, sortColumn, sortType, filterFields } = this.props;

        let value = null;
        let filter = filterFields;
        if (name === 'date') {
            value = event === undefined ? '' : moment(event).format('YYYY-MM-DD');
            changeFilter(name, value);
        } else {
            value = event.target.value;
            changeFilter(name, value);
        }

        let fetch = false;
        const index = filter.findIndex(element => element['name'] === name);
        if (index === -1 && value !== '') {
            filter.push({ name: name, value: value });
            fetch = true;
        } else if (index !== -1 && value === '') {
            filter.splice(index, 1);
            fetch = true;
        } else if (index !== -1 && value !== '' && filter[index]['value'] !== value) {
            filter[index]['value'] = value;
            fetch = true;
        }

        if (fetch) {
            fetchElements(1, sortColumn, sortType, filter);
        }
    }

    handleShowDiscountTable(id) {
        const { showDiscountTable, fetchElement } = this.props;
        fetchElement(id);
        showDiscountTable();
    }

    handleAddDiscount() {
        let { addDiscount } = this.props;
        addDiscount();
    }

    handleDeleteDiscount(ind) {
        let { deleteDiscount } = this.props;
        deleteDiscount(ind);
    }

    handleSaveDiscountTable() {
        const { saveDiscountTable, discountTable, activeElement, elements } = this.props;
        saveDiscountTable(discountTable, elements, activeElement['id']);
    }

    handleSetActivePage(page) {
        const { fetchElements, setActivePage, sortColumn, sortType, filterFields } = this.props;
        setActivePage(page);
        fetchElements(page, sortColumn, sortType, filterFields);
    }

    render() {
        const { isFetchingElements, elements, sortColumn, sortType, totalPages, selectedPage, elementsPerPage, user,
            isSavingForm, formValues, formErrors, isFetchingElement, hideForm, isDeleting, hideDelete, formErrorMessages,
            isSavingActivePapers, activePapers, hideActivePapers, isFetchingInformation, hideDiscountTable,
            speedTable, hideSpeedTable, isSavingSpeedTable, processedElements, information,
            options, fetching, activeElement, discountTable, isSavingDiscountTable, updateDiscount } = this.props;
        return (
            <Layout>
                <div id="admin-dashboard-container" className="container-fluid">
                    <Helmet>
                        <title>Dashboard</title>
                        <meta name="description" content="" />
                    </Helmet>
                    <AdminHeader
                        title="Digital Machines"
                    />
                    <div className="row">
                        <div className="col">
                            <Tabs
                                user={user}
                            />
                            <div className="upload-button" onClick={this.handleShowForm.bind(this, null)}><i className="fas fa-plus" /> Add</div>
                            <Table
                                elements={elements}
                                isFetchingElements={isFetchingElements}
                                totalItems={this.props.totalItems}
                                totalPages={totalPages}
                                selectedPage={selectedPage}
                                elementsPerPage={elementsPerPage}
                                sortColumn={sortColumn}
                                sortType={sortType}
                                user={user}
                                processedElements={processedElements}
                                handleSort={this.handleSort.bind(this)}
                                handleChangeAttribute={this.handleChangeAttribute.bind(this)}
                                handleInlineChange={this.handleInlineChange.bind(this)}
                                handleShowDelete={this.handleShowDelete.bind(this)}
                                handleShowForm={this.handleShowForm.bind(this)}
                                handleDayChange={this.handleDayChange.bind(this)}
                                handleShowActivePapers={this.handleShowActivePapers.bind(this)}
                                handleShowSpeedTable={this.handleShowSpeedTable.bind(this)}
                                handleChangeFilter={this.handleChangeFilter.bind(this)}
                                handleShowDiscountTable={this.handleShowDiscountTable.bind(this)}
                                handleSetActivePage={this.handleSetActivePage.bind(this)}
                            />
                            <Form
                                formValues={formValues}
                                formErrors={formErrors}
                                formErrorMessages={formErrorMessages}
                                isSavingForm={isSavingForm}
                                isFetchingElement={isFetchingElement}
                                options={options}
                                information={information}
                                fetching={fetching}
                                handleUpdateFormValue={this.handleUpdateFormValue.bind(this)}
                                handleUpdateDayValue={this.handleUpdateDayValue.bind(this)}
                                hideForm={hideForm.bind(this)}
                                handleSaveElement={this.handleSaveElement.bind(this)}
                            />
                            <ActivePapers
                                activePapers={activePapers}
                                isSavingActivePapers={isSavingActivePapers}
                                isFetchingInformation={isFetchingInformation}
                                information={information}
                                options={options}
                                fetching={fetching}
                                formValues={formValues}
                                isFetchingElement={isFetchingElement}
                                hideActivePapers={hideActivePapers.bind(this)}
                                handleSaveActivePapers={this.handleSaveActivePapers.bind(this)}
                                handleUpdateFormValue={this.handleUpdateFormValue.bind(this)}
                                handleAddActivePaper={this.handleAddActivePaper.bind(this)}
                                handleDeleteActivePaper={this.handleDeleteActivePaper.bind(this)}
                                handleMultipleChange={this.handleMultipleChange.bind(this)}
                            />
                            <SpeedTable
                                speedTable={speedTable}
                                isSavingSpeedTable={isSavingSpeedTable}
                                isFetchingElement={isFetchingElement}
                                hideSpeedTable={hideSpeedTable.bind(this)}
                                handleAddSpeedTable={this.handleAddSpeedTable.bind(this)}
                                handleUpdateSpeedTable={this.handleUpdateSpeedTable.bind(this)}
                                handleDeleteSpeedTable={this.handleDeleteSpeedTable.bind(this)}
                                handleSaveSpeedTable={this.handleSaveSpeedTable.bind(this)}
                            />
                            <Delete
                                isDeleting={isDeleting}
                                hideDelete={hideDelete.bind(this)}
                                handleDeleteElement={this.handleDeleteElement.bind(this)}
                            />
                            <DiscountTable
                                activeElement={activeElement}
                                discountTable={discountTable}
                                isSavingDiscountTable={isSavingDiscountTable}
                                isFetchingElement={isFetchingElement}
                                hideDiscountTable={hideDiscountTable.bind(this)}
                                handleSaveDiscountTable={this.handleSaveDiscountTable.bind(this)}
                                handleAddDiscount={this.handleAddDiscount.bind(this)}
                                handleDeleteDiscount={this.handleDeleteDiscount.bind(this)}
                                updateDiscount={updateDiscount.bind(this)}
                            />
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    formValues: selectors.getFormValues,
    formErrors: selectors.getFormErrors,
    formErrorMessages: selectors.getFormErrorsMessages,
    isSavingForm: selectors.getIsSavingForm,
    elements: selectors.getElements,
    processedElements: selectors.getProcessedElements,
    isFetchingElements: selectors.getIsFetchingElements,
    isFetchingElement: selectors.getIsFetchingElement,
    isDeleting: selectors.getIsDeleting,
    idForDelete: selectors.getIdForDelete,
    totalItems: selectors.getTotalItems,
    totalPages: selectors.getTotalPages,
    selectedPage: selectors.getSelectedPage,
    elementsPerPage: selectors.getElementsPerPage,
    sortColumn: selectors.getSortColumn,
    sortType: selectors.getSortType,
    activeElement: selectors.getActiveElement,
    activePapers: selectors.getActivePapers,
    isSavingActivePapers: selectors.getIsSavingActivePapers,
    isFetchingInformation: selectors.getIsFetchingInformation,
    information: selectors.getInformation,
    options: selectors.getOptions,
    fetching: selectors.getFetching,
    user: loginSelectors.getUser,
    speedTable: selectors.getSpeedTable,
    isSavingSpeedTable: selectors.getIsSavingSpeedTable,
    discountTable: selectors.getDiscountTable,
    filterFields: selectors.getFilterFields,
    isSavingDiscountTable: selectors.getIsSavingDiscountTable
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchElements: (selectedPage, sortColumn, sortType, filterFields) => dispatch(actions.fetchElements(selectedPage, sortColumn, sortType, filterFields)),
        updateFormValue: (name, value) => dispatch(actions.updateFormValue(name, value)),
        setSort: (column, type) => dispatch(actions.setSort(column, type)),
        deleteElement: (elements, index) => dispatch(actions.deleteElement(elements, index)),
        showDelete: () => dispatch(dialog.actions.showDialog('delete')),
        hideDelete: () => dispatch(dialog.actions.hideDialog('delete')),
        showForm: () => dispatch(dialog.actions.showDialog('form')),
        hideForm: () => dispatch(dialog.actions.hideDialog('form')),
        showActivePapers: () => dispatch(dialog.actions.showDialog('active-papers')),
        hideActivePapers: () => dispatch(dialog.actions.hideDialog('active-papers')),
        setIdForDelete: (value) => dispatch(actions.setIdForDelete(value)),
        saveElement: (values, elements) => dispatch(actions.saveElement(values, elements)),
        setFormError: (name, value, message) => dispatch(actions.setFormError(name, value, message)),
        resetForm: () => dispatch(actions.resetForm()),
        changeAttribute: (value, elements, index, attribute) => dispatch(actions.changeAttribute(value, elements, index, attribute)),
        updateAttribute: (id, attribute, value, elements, index) => dispatch(actions.updateAttribute(id, attribute, value, elements, index)),
        setActiveElement: (elements, id) => dispatch(actions.setActiveElement(elements, id)),
        saveActivePapers: (activePapers, elements, pressId) => dispatch(actions.saveActivePapers(activePapers, elements, pressId)),
        fetchInformation: () => dispatch(actions.fetchInformation()),
        showSpeedTable: () => dispatch(dialog.actions.showDialog('speed-table')),
        hideSpeedTable: () => dispatch(dialog.actions.hideDialog('speed-table')),
        setSpeedTable: (speedTable) => dispatch(actions.setSpeedTable(speedTable)),
        saveSpeedTable: (speedTable, elements, pressId) => dispatch(actions.saveSpeedTable(speedTable, elements, pressId)),
        addActiveData: (data, dataName) => dispatch(actions.addActiveData(data, dataName)),
        deleteActiveData: (index, dataName) => dispatch(actions.deleteActiveData(index, dataName)),
        concatActiveData: (name, data) => dispatch(actions.concatActiveData(name, data)),
        addMultipleValue: (name, value) => dispatch(actions.addMultipleValue(name, value)),
        clearMultipleValue: (name) => dispatch(actions.clearMultipleValue(name)),
        concatMultipleValue: (name, data) => dispatch(actions.concatMultipleValue(name, data)),
        resetState: () => dispatch(actions.resetState()),
        setLoading: (name, value) => dispatch(actions.setLoading(name, value)),
        resetOptions: (name) => dispatch(actions.resetOptions(name)),
        fetchPaperCategories: () => dispatch(actions.fetchPaperCategories()),
        fetchPaperWeights: (paperCategoryId) => dispatch(actions.fetchPaperWeights(paperCategoryId)),
        fetchPapers: (paperCategoryId, paperWeight) => dispatch(actions.fetchPapers(paperCategoryId, paperWeight)),
        updateState: (values) => dispatch(actions.updateState(values)),
        changeFilter: (name, value) => dispatch(actions.changeFilter(name, value)),
        showDiscountTable: () => dispatch(dialog.actions.showDialog('discount-table')),
        hideDiscountTable: () => dispatch(dialog.actions.hideDialog('discount-table')),
        saveDiscountTable: (discountTable, elements, productId) => dispatch(actions.saveDiscountTable(discountTable, elements, productId)),
        addDiscount: () => dispatch(actions.addDiscount()),
        deleteDiscount: (index) => dispatch(actions.deleteDiscount(index)),
        updateDiscount: (index, field, value) => dispatch(actions.updateDiscount(index, field, value)),
        fetchElement: (id) => dispatch(actions.fetchElement(id)),
        setActivePage: (page) => dispatch(actions.setActivePage(page))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
